import { Loader2, Send } from "lucide-react";

export function ChatbotInput({
  input,
  setInput,
  sending,
  activePersonaName,
  expanded,
  onSend,
}) {
  const onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <div className="border-t border-rp-border bg-rp-bg p-3 shrink-0">
      <div className={expanded ? "max-w-3xl mx-auto w-full flex items-end gap-2" : "flex items-end gap-2"}>
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={onKeyDown}
          rows={1}
          placeholder={`Ask ${activePersonaName || "the mentor"}…`}
          className="flex-1 resize-none rounded-lg border border-rp-border bg-rp-surface px-3 py-2 text-sm text-rp-text placeholder:text-rp-textFaint focus:outline-none focus:border-emerald-500/60 max-h-24"
          disabled={sending}
          data-testid="chatbot-input"
        />
        <button
          type="button"
          onClick={onSend}
          disabled={sending || !input.trim()}
          className="rounded-lg bg-emerald-500 hover:bg-emerald-400 disabled:bg-rp-border disabled:text-rp-textFaint text-white px-3 py-2 transition-colors"
          aria-label="Send message"
          data-testid="chatbot-send"
        >
          {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
        </button>
      </div>
    </div>
  );
}
